import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const ZendwebServices: React.FC<Props> = ({ title }) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
                Moweb house a skilled and expert Zend Framework development team, which believes in exploring all the Zend characteristics to the fullest in order to leverage result-driven and classy web solution that appeals your imagination. Hire Zend developers in a quite cost-effective hiring model at your offshore center and get your business solution tailored as per your needs and requirements.
              </p>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Business-centered Solution" />
              <KEYBlue text="No Hidden Charges" />
              <KEYBlue text="Access to Skilled and Certified Zend Developers" />
              <KEYBlue text="Compliance with Latest Industry Standards" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Quick Turnaround Time" />
              <KEYBlue text="Flexible Hiring Model" />
              <KEYBlue text="Total Project Management Control" />
              <KEYBlue text="Start Your Project Designing" />
              <KEYBlue text="Online Assistance" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ZendwebServices